import { xsollaStore } from '../xsollaStore';
import { httpApi } from 'core/httpApi';

export const setToken = (token: string | undefined) => {
    httpApi.setToken(token);
    xsollaStore.setToken(token);
};
